export default __webpack_public_path__ + "static/media/yellow-ball.f9c0f9c2.svg";